import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ToastProvider } from "./components/toast/ToastProvider";
import "./theme/tailwind.css";
import "./theme/global.css";

// 배포 뒤에도 열려 있던 옛 화면은 다음 화면의 조각(/assets/*-해시.js)을 옛 이름으로 찾는다.
// nginx 는 없는 경로에 index.html 을 돌려주므로 조각 읽기가 깨지고 메뉴 이동이 멈춘다
// (사용자 보고 2026-10-26 「오래 안 건드리다가 이동하려면 새로고침해야 됨」). Vite 가
// 그 실패를 vite:preloadError 로 알려 주면 한 번 새로고침해 새 index.html 을 받는다.
// 새로고침해도 또 실패하면(같은 분 안) 멈춰 무한 새로고침을 막는다.
window.addEventListener("vite:preloadError", (e) => {
  const k = "csms.chunk_reload";
  const last = Number(sessionStorage.getItem(k) ?? 0);
  if (Date.now() - last < 60_000) return;
  sessionStorage.setItem(k, String(Date.now()));
  e.preventDefault();
  location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
